//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/design-components";
import NsSearchbarTooltip from "./NsSearchbarTooltip.vue";

export default {
  name: "NsSearchbarInput",
  components: { NsSearchbarTooltip, NsIcon },
  props: {
    newHeader: Boolean,
    focused: Boolean,
    value: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default: function() {
        return {};
      }
    },
    noSearchButton: Boolean,
    showTooltip: Boolean
  },
  computed: {
    placeholderText() {
      if (window.outerWidth > 1023) {
        return this.translations.desktopPlaceholder || "";
      } else if (this.translations.mobilePlaceholder) {
        return this.translations.mobilePlaceholder || "";
      } else {
        return this.translations.desktopPlaceholder || "";
      }
    }
  },
  watch: {
    focused(isFocused) {
      if (isFocused) {
        this.$refs.input.focus();
      } else {
        this.$refs.input.blur();
      }
    }
  },
  methods: {
    clearInput() {
      this.$emit("clear-input");
      this.$refs.input.focus();
    }
  }
};
